import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { AnimatePresence } from 'framer-motion';
import ApprovalCard from './ApprovalCard';
import DataModeBadge from '../../components/feedback/DataModeBadge';

function ApprovalsPage({ approvals, mode = 'sample', selected, setSelected, onAction }) {
  return (
    <main className="page-content">
      <section className="page-heading">
        <div>
          <p className="eyebrow">HUMAN-IN-THE-LOOP</p>
          <h1>
            Approval queue <DataModeBadge mode={mode} />
          </h1>
          <span>Review and authorize consequential agent actions.</span>
        </div>
        <button className="filter-button" type="button">
          <FiIcons.FiSliders />
          Filter queue
        </button>
      </section>

      <section className="queue-summary">
        <div><strong>{approvals.length}</strong><span>Awaiting review</span></div>
        <div><strong>4m 12s</strong><span>Median response</span></div>
        <div><strong>98.7%</strong><span>Within SLA</span></div>
        <div className="shortcut-tip">
          <kbd>A</kbd>
          <kbd>R</kbd>
          <kbd>M</kbd>
          <span>Keyboard shortcuts active</span>
        </div>
      </section>

      <div className="queue-header">
        <span>Priority queue</span>
        <small>Sorted by risk and age</small>
      </div>

      <section className="approval-list">
        <AnimatePresence mode="popLayout">
          {approvals.map((approval) => (
            <ApprovalCard
              approval={approval}
              key={approval.id}
              selected={selected === approval.id}
              onSelect={setSelected}
              onAction={onAction}
            />
          ))}
        </AnimatePresence>

        {!approvals.length && (
          <div className="empty-queue">
            <FiIcons.FiCheckCircle />
            <h3>Queue cleared</h3>
            <p>All consequential actions have been reviewed.</p>
          </div>
        )}
      </section>
    </main>
  );
}

export default ApprovalsPage;